import React from "react"
import {Grid, Responsive} from "semantic-ui-react";

const isMobile = () => {
    return  window.innerWidth - Responsive.onlyMobile.maxWidth < 0;
}

const MainButtonsContainer = ({ title, onEdit, children, style, mode}) => {

    return (
        <Grid style={{...style}} className={isMobile() ? "mainButtonsContainerMobile" : ""}>

            {/*{*/}
                {/*mode === "sample" &&*/}
                {/*<Grid.Row columns={1} style={{paddingBottom:0,marginTop:'0', paddingTop:0}}>*/}
                    {/*<Grid.Column style={{padding:0}}>*/}
                        {/*<div className="prelevementModeLine">*/}
                            {/*<div className="prelevementModeCard">*/}
                                {/*<FontAwesomeIcon icon={faVials} style={{fontSize:'0.9em',marginRight:3}}/> Mode PRÉLÈVEMENT*/}
                            {/*</div>*/}

                        {/*</div>*/}
                    {/*</Grid.Column>*/}
                {/*</Grid.Row>*/}

            {/*}*/}
            {/*{*/}
                {/*mode === 'edit' &&*/}
                {/*<Grid.Row columns={1} style={{paddingBottom:0,marginTop:'0',paddingTop:0}}>*/}
                    {/*<Grid.Column style={{padding:0}}>*/}
                        {/*<div className="editionModeLine">*/}
                            {/*<div className="editionModeCard">*/}
                                {/*<Icon name="edit outline" size="small" style={{marginRight:3}}/> Mode ÉDITION*/}
                            {/*</div>*/}

                        {/*</div>*/}
                    {/*</Grid.Column>*/}
                {/*</Grid.Row>*/}
            {/*}*/}


            {children}



        </Grid>

    )
}

export default MainButtonsContainer